/* global axios */
import ApiClient from './ApiClient';
import { requestConfig, resourcePath, withQuery } from './lais/httpHelpers';

class SalesPropertyLookupsAPI extends ApiClient {
  constructor() {
    super('sales_property_lookup', { accountScoped: true });
  }

  lookup(code) {
    return axios.get(withQuery(this.url, { code }), requestConfig());
  }

  confirm(payload = {}) {
    return axios.post(
      resourcePath(this.url, 'confirm'),
      payload,
      requestConfig()
    );
  }

  analyzeOnus(file, onUploadProgress) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(resourcePath(this.url, 'onus_analysis'), formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress,
    });
  }
}

export default new SalesPropertyLookupsAPI();
